import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import isUndefined from 'lodash/isUndefined'

import colors from 'components/utils/colors'
import { StyledTableCellWithActions } from './TableCellWithActions'
import { StyledTableCellAction } from './TableCellAction'
import { StyledShowOnRowHover } from './ShowOnRowHover'
import { StyledIcon } from 'components/Shared/Icon/Index'

export const StyledTableRow = styled.tr`
  height: 40px;

  ${StyledTableCellAction}, ${StyledShowOnRowHover} {
    visibility: hidden;
  }

  &:hover {
    ${StyledTableCellAction}, ${StyledShowOnRowHover} {
      visibility: visible;
    }
    ${StyledTableCellWithActions} {
      ${StyledIcon} {
        &:hover::before {
          // recover icon highlight color
          color: ${colors.primary40};
        }
        &:before {
          color: ${colors.secondary40};
        }
      }
    }
  }

  // Need this to properly render left border color in Firefox
  // See https://ccp.sys.comcast.net/browse/RELAY-579
  border-left: 0px solid;

  ${props => props.color && css`
    border-left: 4px solid ${props => props.color};
  `}

  &&&& {
    transition: all .15s linear;

    ${props => props.active && css`
      background-color: ${colors.primary80};
      color: ${colors.secondary20};
    `}

    ${props => !isUndefined(props.hoverable) && css`
      &:hover {
        background-color: ${props => props.hoverable ? colors.primary90 : 'initial'};
      }
    `}

    ${props => !isUndefined(props.clickable) && css`
      &:hover {
        cursor: ${props => props.clickable ? 'pointer' : 'default'};
      }
    `}
  }
`

const TableRow = ({ children, color, innerRef, active, ...otherProps }) => {
  return (
    <StyledTableRow
      color={color}
      active={active}
      ref={innerRef}
      {...otherProps}
    >
      {children}
    </StyledTableRow>
  )
}

TableRow.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  active: PropTypes.bool,
}

export default TableRow
